import { CardHeader, CardContent, Card, Divider, Box } from "@mui/material";
import NeighborhoodPerformance from "./NeighborhoodPerformance";

type Props = {

};

const NeighborhoodPerformanceView = function NeighborhoodUsageView(props: Props) {
  return <Box component="div">
    <Card sx={{ minHeight: '34em' }}>
      <CardHeader title="Neighborhood performance" />
      <Divider />
      <CardContent>
        <NeighborhoodPerformance />
      </CardContent>
    </Card>
  </Box>
}

export default NeighborhoodPerformanceView;
